import * as actions from "../actions/actions";
import { connect } from "react-redux";

import React from "react";

let $window = require("../legacy/helpers/helpers").default.window;

class Carousel extends React.Component {
    constructor(props) {
        super(props);

        let pageSize = this.props.itemsPerView,
            numberOfPages = this.props.items.length / pageSize,
            nextDisabled = numberOfPages <= 1 ? true : false;

        if ($window.width() <= 960) {
            pageSize = 1;
        }

        this.state = {
            page: 1,
            pageSize: pageSize,
            previousDisabled: true,
            nextDisabled: nextDisabled,
            lastPage: numberOfPages
        };
    }

    sliceCurrentItems(items) {
        // Figure out where to slice from base 0 items.
        let start = (this.state.page - 1) * this.state.pageSize,
            end = this.state.page * this.state.pageSize;
        return items.slice(start, end);
    }

    render() {
        if (this.props.items.length <= 0) {
            // No items, show loading state
            return <div>Loading…</div>;
        }

        return (
            <div>
                <div
                    className={`collection-list_arrow left-arrow ui_left-arrow ${
                        this.state.previousDisabled ? "disabled" : ""
                    }`}
                    onClick={this.showPrevious.bind(this)}
                />
                <div className="carousel margin-t-s">
                    {this.sliceCurrentItems(this.props.items)}
                </div>
                <div
                    className={`collection-list_arrow right-arrow ui_right-arrow ${
                        this.state.nextDisabled ? "disabled" : ""
                    }`}
                    onClick={this.showNext.bind(this)}
                />
            </div>
        );
    }

    showPrevious() {
        if (!this.state.previousDisabled) {
            let page = this.state.page - 1,
                previousDisabled = false;

            if (page === 1) {
                previousDisabled = true;
            }

            this.setState({
                page: page,
                previousDisabled: previousDisabled,
                nextDisabled: false
            });
        }
    }

    showNext() {
        if (!this.state.nextDisabled) {
            let nextDisabled = false,
                page = this.state.page + 1;

            if (page >= this.state.lastPage) {
                nextDisabled = true;
            }

            this.setState({
                page: page,
                previousDisabled: false,
                nextDisabled: nextDisabled
            });
        }
    }
}

module.exports = connect(null, {
    setFeaturedCarouselPage: actions.setFeaturedCarouselPage
})(Carousel);
